/*
 * Events in the context of data loading. Used in context where fine-grained control
 * over the flow of data loading requests is required.
 */

export const BEFORE_LOAD_DATA = 'before-load:data';
export const AFTER_LOAD_DATA = 'after-load:data';
export const LOAD_DATA = 'load:data';
export const LOAD_DATA_CANCELED = 'cancel:data';
export const ERROR_LOAD_DATA = 'error-load:data';
